module.exports = __webpack_public_path__ + "media/images/yarn-7357b97f3eb4e715f6c8384bd0cc89b9.svg";